import type {UILayout} from 'swayok-react-mdb-ui-kit/types/Common'
import {
    useAccountFlagsStore,
    useUiLayoutStore,
} from '../../../../../stores'
import {GetAdvancePromoCard} from '../../../../layout/promo_cards/GetAdvancePromoCard'
import {PromoteYourAdsPromoCard} from '../../../../layout/promo_cards/PromoteYourAdsPromoCard'
import {RepayAdvanceAfterSellPromoCard} from '../../../../layout/promo_cards/RepayAdvanceAfterSellPromoCard'
import type {AdsListGridColumnsConfig} from '../../AdsModuleTypes'

interface AdsGridPromoBannersProps {
    listUid: string
    gridColumns: AdsListGridColumnsConfig
    sideMenuVisibleFromBsBreakpoint?: UILayout['bootstrapSize']
}

// Промо-баннеры для сетки объявлений.
export function AdsGridPromoBanners(props: AdsGridPromoBannersProps) {
    const {
        listUid,
        sideMenuVisibleFromBsBreakpoint = 'xl',
        gridColumns,
    } = props

    const bootstrapSize = useUiLayoutStore(
        state => state.bootstrapSize
    )

    const isSeller: boolean = useAccountFlagsStore(
        state => state.isSeller
    )

    const utmSource = listUid + '_items_grid'
    const gridInfo = getGridOrderAndColSpan(bootstrapSize, 2, gridColumns)
    const bannerSize = getBannerSize(bootstrapSize, sideMenuVisibleFromBsBreakpoint)

    if (!isSeller) {
        switch (bootstrapSize) {
            case 'xxs':
            case 'xs':
            case 'sm':
                return (
                    <div
                        style={{
                            order: gridInfo.gridOrder,
                            gridColumn: `span ${gridInfo.colSpan}`,
                        }}
                    >
                        <PromoteYourAdsPromoCard
                            className="inside-items-list"
                            utmSource={utmSource}
                            size={bannerSize}
                        />
                    </div>
                )
            default:
                return null
        }
    }

    // Пользователь авторизован и имеет хотя-бы одно объявление.
    return (
        <div
            className="d-grid grid-columns-1 grid-columns-md-2 gap-medium"
            style={{
                order: gridInfo.gridOrder,
                gridColumn: `span ${gridInfo.colSpan}`,
            }}
        >
            <GetAdvancePromoCard
                className="inside-items-list"
                utmSource={utmSource}
                size={bannerSize}
            />
            <RepayAdvanceAfterSellPromoCard
                className="inside-items-list"
                utmSource={utmSource}
                size={bannerSize}
            />
        </div>
    )

}

// Получить порядок элемента в сетке для промо-баннера.
function getGridOrderAndColSpan(
    bsScreenSize: UILayout['bootstrapSize'],
    row: number,
    gridColumns: AdsListGridColumnsConfig
): {
    gridOrder: number
    colSpan: number
    bannerSize: 'md' | 'sm'
} {
    // Порядок (order) объявления в сетке указывается с шагом 10,
    // поэтому нужно найти order последнего элемента в строке row и добавить к нему 1,
    // чтобы вставить баннер в начало следующей строки.
    // Кол-во объявлений в строке передается в gridColumns[bsScreenSize].
    return {
        gridOrder: (gridColumns[bsScreenSize] * row * 10) + 1,
        colSpan: gridColumns[bsScreenSize],
        bannerSize: bsScreenSize === 'lg' || bsScreenSize === 'xl' || bsScreenSize === 'xxl'
            ? 'md'
            : 'sm',
    }
}

// Получить размер баннера для сетки объявлений.
function getBannerSize(
    bsScreenSize: UILayout['bootstrapSize'],
    _sideMenuVisibleFromBsBreakpoint: UILayout['bootstrapSize']
): 'sm' | 'md' | 'lg' {
    switch (bsScreenSize) {
        case 'xs':
            return 'sm'
        case 'sm':
        case 'xxl':
            return 'lg'
        case 'md':
            return 'sm'
        default:
            return 'md'
    }
}
